export const AI_QUESTION_GENERATOR_RETURN_KEY = "aiQuestionGeneratorReturn";
export const AI_QUESTION_GENERATOR_REOPEN_KEY = "aiQuestionGeneratorReopen";

export const getQuestionGeneratorReturn = () => {
  if (typeof window === "undefined") return null;
  try {
    const raw = sessionStorage.getItem(AI_QUESTION_GENERATOR_RETURN_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const saveQuestionGeneratorReturn = ({ path, modal, form }) => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(
    AI_QUESTION_GENERATOR_RETURN_KEY,
    JSON.stringify({ path, modal, form, restore: false })
  );
};

export const markQuestionGeneratorReopen = () => {
  const data = getQuestionGeneratorReturn();
  if (typeof window === "undefined") return data;
  if (data) {
    sessionStorage.setItem(
      AI_QUESTION_GENERATOR_RETURN_KEY,
      JSON.stringify({ ...data, restore: true })
    );
    sessionStorage.setItem(AI_QUESTION_GENERATOR_REOPEN_KEY, data.modal);
  } else {
    sessionStorage.setItem(AI_QUESTION_GENERATOR_REOPEN_KEY, "createQuestions");
  }
  return data;
};

export const consumeQuestionGeneratorReopen = () => {
  if (typeof window === "undefined") return null;
  const modal = sessionStorage.getItem(AI_QUESTION_GENERATOR_REOPEN_KEY);
  if (modal) sessionStorage.removeItem(AI_QUESTION_GENERATOR_REOPEN_KEY);
  return modal;
};
